<!-- START OF MAIN -->
<main class="site-main">
    <!-- START OF MAIN BANNER -->
    <section class="inner-banner back-img" style="background-image: url('assets/img/about-us-banner-new.jpg');">
        <div class="banner-stripes">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="banner-shape-wp wow fadeInRight for-des" data-wow-duration=".8s">
            <div class="banner-shape">
                <span class="stripe"></span>
                <span class="stripe stripe-secondary"></span>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="inner-banner-content-wp white-text text-center">
                        <div class="inner-banner-content wow fadeInUp" data-wow-duration=".8s">
                            <h2 class="h2-title mb-0 mt-5">{{currentProduct?.name}}</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF MAIN BANNER -->
    <!-- START OF MAIN SERVICE -->
    <section class="service-main-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 order-lg-1 order-2">
                    <div class="service-sidebar wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".2s">
                        <div class="service-list-box light-bg">
                            <h4 class="h4-title">Other Products</h4>
                            <div class="service-list">
                                <ul>
                                    <ng-container *ngFor="let prod of productsArr;let p = index;">
                                        <li [ngClass]="{ 'current-service': productId == prod?.id }">
                                            <a routerLink="/product-details/{{prod?.id}}" class="sec-btn detail"
                                                [title]="prod?.name">
                                                {{prod?.name}}
                                            </a>
                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </div>
                        <div class="service-sidebar-image">
                            <div class="back-img" style="background-image: url('assets/img/banner-image-oil.jpg');">
                            </div>
                            <div class="service-sidebar-contact-wp">
                                <div class="service-sidebar-contact">
                                    <div class="white-text">
                                        <span>Get In Touch Now</span>
                                        <a href="tel:+971581292000" class="h4-title"
                                            title="Call to +971 58 129 2000">+971 58 129 2000</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8 order-lg-2 order-1">
                    <div class="service-main-box wow fadeInRight" data-wow-duration=".8s" data-wow-delay=".2s">
                        <div class="service-main-content mt-0">
                            <h1 class="h2-title text-theme">
                                {{currentProduct?.name}}
                            </h1>

                            <div class="service-growth">
                                <div class="row">
                                    <div class="col-lg-5">
                                        <img [src]="currentProduct?.image" class="img-fluid">
                                    </div>
                                    <div class="col-lg-7">
                                        <div class="service-growth-content skills m-0">
                                            <h4 class="h4-title">About Product</h4>
                                            <div class="skills-progress" id="counter">
                                                <div class="skills-progress-box">
                                                    <div class="why-choose-content prod-det-point p-0">
                                                        <ul class="m-0 p-0">
                                                            <li class="mb-3" *ngFor="let det of currentProduct?.details">
                                                                <span>{{det?.point}}</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-5" [innerHTML]="currentProduct?.description"></div>
                            <div class="why-choose-content prod-det-point p-0 mb-5" [innerHTML]="currentProduct?.whyBuy"></div>
                            <div class="why-choose-content prod-det-point p-0 mb-5" [innerHTML]="currentProduct?.benefits"></div>
                            <ng-container *ngIf="currentProduct?.application">
                                <div class="why-choose-content prod-det-point p-0 mb-0" [innerHTML]="currentProduct?.application"></div>
                            </ng-container>
                            <!-- <div class="faq-accordian-wp">
                                <h4 class="h4-title">Related Questions to Service</h4>
                                <div class="faq-accordian">
                                    <div class="faq-accordian-box">
                                        <div class="faq-accordian-title">
                                            <h6 class="h6-title">Compliance crucial in product design ?</h6>
                                            <span class="icon"></span>
                                        </div>
                                        <div class="faq-accordian-content">
                                            <p>Quisque sed risus gravida, condimentum risus ac, euismod arcu. Proin
                                                ornare arcu non finibus finibus. Nullam et fringilla quam, sit amet
                                                feugiat eros. Maecenas scelerisque, libero at malesuada tempus,
                                                nulla ante sollicitudin tortor, sed placerat leo lacus ac nisi.</p>
                                        </div>
                                    </div>
                                    <div class="faq-accordian-box">
                                        <div class="faq-accordian-title">
                                            <h6 class="h6-title">Et harum quidem rerum facilis est et expedita?</h6>
                                            <span class="icon"></span>
                                        </div>
                                        <div class="faq-accordian-content">
                                            <p>Quisque sed risus gravida, condimentum risus ac, euismod arcu. Proin
                                                ornare arcu non finibus finibus. Nullam et fringilla quam, sit amet
                                                feugiat eros. Maecenas scelerisque, libero at malesuada tempus,
                                                nulla ante sollicitudin tortor, sed placerat leo lacus ac nisi.</p>
                                        </div>
                                    </div>
                                    <div class="faq-accordian-box">
                                        <div class="faq-accordian-title">
                                            <h6 class="h6-title">How do I choose right factory for manufacturing ?
                                            </h6>
                                            <span class="icon"></span>
                                        </div>
                                        <div class="faq-accordian-content">
                                            <p>Quisque sed risus gravida, condimentum risus ac, euismod arcu. Proin
                                                ornare arcu non finibus finibus. Nullam et fringilla quam, sit amet
                                                feugiat eros. Maecenas scelerisque, libero at malesuada tempus,
                                                nulla ante sollicitudin tortor, sed placerat leo lacus ac nisi.</p>
                                        </div>
                                    </div>
                                    <div class="faq-accordian-box">
                                        <div class="faq-accordian-title">
                                            <h6 class="h6-title">What is the process of product manufacturing ?</h6>
                                            <span class="icon"></span>
                                        </div>
                                        <div class="faq-accordian-content">
                                            <p>Quisque sed risus gravida, condimentum risus ac, euismod arcu. Proin
                                                ornare arcu non finibus finibus. Nullam et fringilla quam, sit amet
                                                feugiat eros. Maecenas scelerisque, libero at malesuada tempus,
                                                nulla ante sollicitudin tortor, sed placerat leo lacus ac nisi.</p>
                                        </div>
                                    </div>
                                    <div class="faq-accordian-box">
                                        <div class="faq-accordian-title">
                                            <h6 class="h6-title">Do we have the best business services ?</h6>
                                            <span class="icon"></span>
                                        </div>
                                        <div class="faq-accordian-content">
                                            <p>Quisque sed risus gravida, condimentum risus ac, euismod arcu. Proin
                                                ornare arcu non finibus finibus. Nullam et fringilla quam, sit amet
                                                feugiat eros. Maecenas scelerisque, libero at malesuada tempus,
                                                nulla ante sollicitudin tortor, sed placerat leo lacus ac nisi.</p>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF MAIN SERVICE -->
</main>
<!-- START OF FOOTER -->